import { Checkbox as DefaultCheckbox, List } from "antd";
import LinkNext from "shared/components/custom/Link";
import styled from "styled-components";

interface IListItem {
  checked?: boolean;
}

export const ListItem = styled(List)<IListItem>`
  cursor: pointer;
  border: 2px solid rgb(232, 232, 232, 0.6);
  border-radius: 5px;
  padding: 10px;
  margin: 0px 10px 10px 10px;

  img.image_thumb {
    width: 115px;
    height: 70px;
    border-radius: 10px;
  }

  &:hover {
    background-color: rgb(232, 232, 232, 0.4);
  }

  background-color: ${({ checked }) =>
    checked ? "rgb(232, 232, 232, 0.4)" : ""};
`;

export const Checkbox = styled(DefaultCheckbox)``;

export const CheckboxWrapper = styled.section`
  display: flex;
  justify-content: space-between;

  height: 50px;
`;

export const Link = styled(LinkNext)`
  font-weight: 410;
  font-size: 18px;
`;
